import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../../../../services/popup.service';
import { MapService } from '../../../../../services/map.service';
import { MyStuffService } from '../../../../../services/my-stuff.service';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-removed-maps',
  templateUrl: './removed-maps.component.html',
  styleUrls: ['./removed-maps.component.less']
})
export class RemovedMapsComponent implements OnInit {

  constructor(public popupService: PopupService, public mapService: MapService,
    public myStuffService: MyStuffService) { }

  removedMapsContainerElement: any;
  removedPinsInputElement: any;
  GOOGLE_CLIENT_ID = environment.APP.GOOGLE_CLIENT_ID;
  API_URL = environment.APP.API_URL;
  isDropdownOpen: any = {};

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.deletedMaps) {
      this.myStuffService.fetchDeletedMapsSource.next(true);
      this.myStuffService.myStuffSectionOpened.deletedMaps = true;     
    }
  }

  openDropdown(index) {
    this.closeAllDropdowns();
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
    (<any>window).Events.publish('detectChanges')
  }

  closeAllDropdowns() {
    Object.keys(this.isDropdownOpen).map((index)=>{
      if(this.isDropdownOpen[index]) {
        this.isDropdownOpen[index] = false;
      }
    });
  }

  closeDropdown(index) {
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
    (<any>window).Events.publish('detectChanges');
  }

  searchMaps() {
    this.myStuffService.resetPagination(this.myStuffService.mapCallFilters.deleted);
    this.myStuffService.getMaps(this.myStuffService.mapCallFilters.deleted);
  }

  ngAfterViewInit() {
    this.addScrollEventObservable();
    this.addInputEventObservable();
  }

  addScrollEventObservable() {
    this.removedMapsContainerElement = document.getElementById('removed-maps-container');
    if(this.removedMapsContainerElement) {
      Observable.fromEvent(this.removedMapsContainerElement, 'ps-y-reach-end')
      .debounceTime(500)
      .subscribe((event) => {
        this.myStuffService.getMaps(this.myStuffService.mapCallFilters.deleted);
      });
    }
  }

  addInputEventObservable() {
    this.removedPinsInputElement = document.getElementById('removed-maps-search-input');
    if(this.removedPinsInputElement) {
      Observable.fromEvent(this.removedPinsInputElement, 'input')
      .debounceTime(500)
      .subscribe((event) => {
        this.searchMaps();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/removed-items/removed-maps/removed-maps.component.ts